function topScroll() {
  if (window.scrollY > 0) {
    document.querySelector('#main').classList.add('is-scrolled-off-top');
  } else {
    document.querySelector('#main').classList.remove('is-scrolled-off-top');
  }
}

function browseScroll() {
  console.log('browseScroll');
  const browseHeaderScroll = document.querySelector(
    '[data-browse-header-scroll]'
  );
  const browseHeader = document.querySelector('[data-browse-header]');
  // const browseBody = document.querySelector('[data-browse]');
  const browseMain = document.querySelector('[data-browse-main-scroll]');
  const browseFilters = document.querySelector('[data-browse-filters-scroll]');
  const siteHeader = document.querySelector('.site-header');
  if (!browseHeaderScroll || !browseMain || !browseFilters || !siteHeader)
    return;

  // is past browse header
  if (window.scrollY + siteHeader.offsetHeight > browseHeaderScroll.offsetTop) {
    document
      .querySelector('#main')
      .classList.add('is-scrolled-past-browse-header');
  } else {
    document
      .querySelector('#main')
      .classList.remove('is-scrolled-past-browse-header');
  }

  // console.log('filter height', browseFilters.offsetHeight);
  // console.log('body top', browseMain.offsetTop);
  // console.log('body height', browseMain.offsetHeight);

  // is past browse filter
  if (
    window.scrollY +
      siteHeader.offsetHeight +
      browseHeader.offsetHeight +
      browseFilters.offsetHeight >
    browseMain.offsetTop + browseMain.offsetHeight
  ) {
    document
      .querySelector('#main')
      .classList.add('is-scrolled-past-browse-filter');
  } else {
    document
      .querySelector('#main')
      .classList.remove('is-scrolled-past-browse-filter');
  }

  // is past browse filter bottom
  if (
    window.scrollY + siteHeader.offsetHeight >
    browseMain.offsetTop + browseMain.offsetHeight
  ) {
    document
      .querySelector('#main')
      .classList.add('is-scrolled-past-browse-bottom');
  } else {
    document
      .querySelector('#main')
      .classList.remove('is-scrolled-past-browse-bottom');
  }

  // check if browseFilters is taller than its parent
  if (browseFilters.offsetHeight > browseFilters.parentElement.offsetHeight) {
    document
      .querySelector('#main')
      .classList.add('is-browse-filter-max-height');
  } else {
    document
      .querySelector('#main')
      .classList.remove('is-browse-filter-max-height');
  }
}

// hide scroll hint
function hintScroll() {
  if (window.scrollY > 0) {
    const scrollHint = document.querySelector('.scroll-hint');
    if (scrollHint) scrollHint.classList.add('is-hidden');
  }
}

function runScrollFunctions() {
  topScroll();
  browseScroll();
  hintScroll();
}

document.addEventListener('scroll', function (e) {
  runScrollFunctions();
});

document.addEventListener('DOMContentLoaded', () => {
  runScrollFunctions();
});
